@if (isLoading()) {
  <div class="wrapper" id="app-spinner">
    <div class="box">
      <img class="logo" src="assets/img/logo-libresalud-cuadrado.png" alt="Libre Salud">
      <div class="spinner"></div>
    </div>
  </div>
}
<div class="page-wrapper" [class.no-padding-bottom]="hideNavbar()" [class.full-bleed-left]="fullBleedLeft()" [hidden]="isLoading()">
  @if (!networkState().online){
    <div class="offline-banner">
      <span>Sin conexión a internet. Reintentá nuevamente.</span>
      <button type="button" (click)="reintentarNetwork()">Reintentar</button>
    </div>
  }
  <router-outlet></router-outlet>
</div>
@if (!hideNavbar()) {
  <app-navbar></app-navbar>
  <app-lia-chat-widget></app-lia-chat-widget>
}

@if (modalVersion()) {
  <div class="update-overlay">
    <div class="update-modal">
      <h2>Nueva versión disponible</h2>
      <p>Hay una nueva version de la app disponible.</p>

      <div class="actions">
        <button class="btn btn-cancel-modal" (click)="closeVersion()">Cancelar</button>
        <button class="btn btn-success-modal" (click)="updateVersion()">Actualizar</button>
      </div>
    </div>
  </div>
}
@if (showUpdateModal()) {
  <div class="update-overlay">
    <div class="update-modal">
      <h2>Nueva versión disponible</h2>
      <p>Hay una actualización disponible de la app.</p>

      <div class="actions">
        <button class="btn btn-cancel-modal" (click)="closeUpdate()">Cancelar</button>
        <button class="btn btn-success-modal" (click)="updateNow()">Actualizar</button>
      </div>
    </div>
  </div>
}